module.exports = __webpack_public_path__ + "static/img/u63.2882a02e.png";